export const WHY_CREHANA_CARDS = [
  {
    title: 'WHY_CREHANA_CARD_TITLE_1',
    description: 'WHY_CREHANA_CARD_DESCRIPTION_1',
    accentColor: '#6F4EF6',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/5d6e1833-fa44-4a19-ac4d-c5899edc4298-01.png?auto=format&fit=clip',
  },
  {
    title: 'WHY_CREHANA_CARD_TITLE_2',
    description: 'WHY_CREHANA_CARD_DESCRIPTION_2',
    accentColor: '#FFB200',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/4d1e561f-ef1e-4304-a695-e32d48016441-02.png?auto=format&fit=clip',
  },
  {
    title: 'WHY_CREHANA_CARD_TITLE_3',
    description: 'WHY_CREHANA_CARD_DESCRIPTION_3',
    accentColor: '#34D69B',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/edf25370-1bd6-4127-a27a-3279db3c5a5c-03-(1).png?auto=format&fit=clip',
  },
  {
    title: 'WHY_CREHANA_CARD_TITLE_4',
    description: 'WHY_CREHANA_CARD_DESCRIPTION_4',
    accentColor: '#40B2FF',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/60f564e9-943f-4a77-b30b-35af1576dca7-04.png?auto=format&fit=clip',
  },
];
